import { CommissionStatuses } from 'constants/commissionStatuses';

import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCheckFinanceAccess } from 'hooks/useCheckFinanceAccess';
import { RecordContextProvider } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { TaskStatusField } from 'shared/react-admin/Fields/TaskStatusField/TaskStatusField';
import {
  CommissionRecalculationTask,
  CommissionRecalculationTaskStatus,
} from 'types/embedded/commissionRecalculationTask';

export type StatusFieldProps = {
  onRecalculation: (record: CommissionRecalculationTask) => void;
  record: CommissionRecalculationTask;
};

export const StatusField: React.FC<StatusFieldProps> = ({ record, onRecalculation }) => {
  const { isHaveFinanceAccess } = useCheckFinanceAccess();

  const commissionStatus = record.commission?.status?.value;
  const isAllowedStatus = [CommissionStatuses.Implemented, CommissionStatuses.Approved].includes(
    commissionStatus as CommissionStatuses,
  );
  const isTaskCreated = record.status.value === CommissionRecalculationTaskStatus.Created;
  const canLaunch = isHaveFinanceAccess && isAllowedStatus && isTaskCreated;

  if (canLaunch) {
    return (
      <Button
        label="Запустить перерасчёт"
        onClick={() => {
          onRecalculation(record);
        }}
        startIcon={<CurrencyExchangeIcon />}
        sx={{
          '.MuiButton-startIcon .MuiSvgIcon-root': {
            fontSize: '18px',
          },
        }}
      />
    );
  }

  return (
    <RecordContextProvider value={record}>
      <TaskStatusField short={true} />
    </RecordContextProvider>
  );
};
